import { Badge } from "@/components/ui";

/**
 * Estatus del acuse de validación (P30):
 * Válido (verde) · No válido (rojo) · Cancelado (gris oscuro) · En proceso (azul).
 */
export function badgeEstatusFactura(estatus: string): { color: string; label: string } {
  switch (estatus) {
    case "Valido":
      return { color: "exito", label: "Válido" };
    case "NoValido":
      return { color: "peligro", label: "No válido" };
    case "Cancelado":
      return { color: "slate", label: "Cancelado" };
    case "EnProceso":
      return { color: "info", label: "En proceso" };
    default:
      return { color: "slate", label: estatus };
  }
}

export function EstatusFacturaBadge({ estatus }: { estatus: string }) {
  const { color, label } = badgeEstatusFactura(estatus);
  return (
    <Badge color={color} variant="light" size="sm">
      {label}
    </Badge>
  );
}
